export const CONFIG = {
  // PRICE: 5,
  PRICE: 6300,
};
